// extracted by mini-css-extract-plugin
export default {"coa-table":"Coa_coa-table__2tim8","coa-table__action":"Coa_coa-table__action__L+8KN","coa-table__action--button":"Coa_coa-table__action--button__ECyLy"};